<template>
  <div class="login-page">
    <div class="login-card">
      <h2 class="title">DDD-DAYZ SHOP</h2>
      <p class="subtitle">输入 SteamID 登录</p>

      <el-form :model="form" label-position="top" :disabled="loading">
        <el-form-item>
          <el-input
            v-model.trim="form.steamId"
            placeholder="例如：7656119xxxxxxxxxx"
            clearable
            @keyup.enter.native="onSubmit"
          />
        </el-form-item>

        <transition name="el-fade-in">
          <el-form-item v-if="showPassphrase" label="设置支付口令（首次登录）">
            <el-input
              v-model.trim="form.passphrase"
              show-password
              placeholder="至少 4 位"
              @keyup.enter.native="onSubmit"
            />
            <div class="hint">请牢记此口令，后续支付会用它确认身份。</div>
          </el-form-item>
        </transition>

        <el-button type="primary" :loading="loading" style="width:100%" @click="onSubmit">
          {{ showPassphrase ? '设置口令并登录' : '登 录' }}
        </el-button>
      </el-form>

      <p class="foot-note">欢迎你，幸存者。</p>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { setSession } from '@/store/session'
import { siteConfigState, ensureSiteConfig } from '@/store/site-config'

const STEAM_ID_PATTERN = /^7656119\d{10}$/

export default {
  name: 'LoginPage', // 多词名称，避免 eslint 警告
  data () {
    return {
      loading: false,
      showPassphrase: false,
      form: { steamId: '', passphrase: '' }
    }
  },
  computed: {
    brandTitle () { return siteConfigState.brandTitle }
  },
  created () {
    ensureSiteConfig()
  },
  methods: {
    async onSubmit () {
      const steamId = (this.form.steamId || '').trim()
      if (!steamId) { this.$message.warning('请输入 SteamID'); return }
      if (!STEAM_ID_PATTERN.test(steamId)) {
        this.$message.warning('请输入正确的 SteamID（17 位数字，以 7656119 开头）')
        return
      }
      this.form.steamId = steamId
      this.loading = true
      try {
        // 首次提交：仅传 steamId（可带上昵称方便后端入库）
        if (!this.showPassphrase) {
          const res = await api.authLogin(steamId, this.form.username) // 调 /api/auth/steam-login
          // 兼容：isNew / needPaySecret / needsPassphrase 任一为真都进入设置口令
          if (res && (res.isNew || res.needPaySecret || res.needsPassphrase)) {
            this.showPassphrase = true
            this.$message.info('检测到首次登录，请设置支付口令')
            this.loading = false
            return
          }
          if (res && res.token && res.user) {
            setSession(res.token, res.user, res.expiresAt)
            this.$message.success('登录成功')
            const redirect = this.$route.query.redirect
            this.$router.replace(redirect || '/servers')
            return
          }
          this.$message.error('未知响应，请检查后端接口')
          return
        }

        // 第二次提交：用户已看到口令输入框，去设置口令并登录
        if (!this.form.passphrase || this.form.passphrase.length < 4) {
          this.$message.warning('支付口令至少 4 位')
          this.loading = false
          return
        }
        const ret = await api.authSetPaySecret(steamId, this.form.passphrase, this.form.username) // 调 /api/auth/set-pay-secret
        if (ret && ret.token && ret.user) {
          setSession(ret.token, ret.user, ret.expiresAt)
          this.$message.success('已设置口令并登录成功')
          const redirect = this.$route.query.redirect
          this.$router.replace(redirect || '/servers')
          return
        }
        this.$message.error('注册失败，请重试')
      } catch (e) {
        this.$message.error((e && e.message) || '请求失败')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.login-page{
  min-height:100vh; display:flex; align-items:center; justify-content:center; background:#0b1320;
}
.login-card{
  width:420px; padding:24px; background:#111b2e; border-radius:16px; box-shadow:0 10px 30px rgba(0,0,0,.3);
}
.title{ color:#fff; margin:0 0 8px; }
.subtitle,.hint,.foot-note{ color:#94a3b8; font-size:12px; }
.subtitle{ margin-bottom:16px; }
.hint{ margin-top:6px; }
.foot-note{ text-align:center; margin-top:12px; }
</style>
